module.exports = (__webpack_require__(0))(71);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/version.js from dll-reference girder_lib
// module id = 136
// module chunks = 0